import { provideHttpClient, withInterceptors } from '@angular/common/http';
import {
    ApplicationConfig,
    inject,
    provideAppInitializer,
    provideBrowserGlobalErrorListeners,
    provideZoneChangeDetection,
} from '@angular/core';
import { UrlSerializer, provideRouter, withRouterConfig } from '@angular/router';

import { routes } from './app.routes';
import { authInterceptor } from './core/auth.interceptor';
import { CaseInsensitiveUrlSerializer } from './core/case-insensitive-url.serializer';
import { errorInterceptor } from './core/error.interceptor';
import { TokenRefreshService } from './core/token-refresh.service';

export const appConfig: ApplicationConfig = {
    providers: [
        provideBrowserGlobalErrorListeners(),
        provideZoneChangeDetection({ eventCoalescing: true }),
        provideRouter(routes, withRouterConfig({ paramsInheritanceStrategy: 'always' })),
        { provide: UrlSerializer, useClass: CaseInsensitiveUrlSerializer },
        provideHttpClient(withInterceptors([authInterceptor, errorInterceptor])),
        provideAppInitializer(() => inject(TokenRefreshService).scheduleProactiveRefresh()),
    ],
};
